const SendToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

export default SendToTop;